import { render } from "./allPayments.vue?vue&type=template&id=7e7256d5&scoped=true"
import script from "./allPayments.vue?vue&type=script&lang=js"
export * from "./allPayments.vue?vue&type=script&lang=js"

import "./allPayments.vue?vue&type=style&index=0&id=7e7256d5&scoped=true&lang=css"

import exportComponent from "/mnt/extra-storage/gafwa_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e7256d5"]])

export default __exports__